import React from "react";
import retryChunkLoader from "../../helpers/chunkLoadRetry";

export const WhatsNewLazy = React.lazy(() =>
  retryChunkLoader(() => import("./index" /* webpackChunkName "whatsnew" */).then((m) => ({ default: m.WhatsNew }))),
);
